import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { LoggerService } from '../shared/logger.service';

export const cookieInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);
  //  const cookieService = inject(CookieService);
  const cookieReq = req.clone({
    withCredentials: true
  });
  // logger.debug('cookieInterceptor...', cookieReq);
  return next(cookieReq);
};
